export default import.meta.ROLLDOWN_FILE_URL_Zv7_dbtRkTerJzhi5biZkQ